import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';

import { environment } from 'src/environments/environment';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { FormDataService } from '../../base-data-services/form-data.service';
import moment from 'moment';
import { AppVersionModel } from 'common/models/page-models/App Version Model/app-version-form-model';

@Injectable({
  providedIn: 'root',
})
export class AppVersionFormDataService extends FormDataService<AppVersionModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.appManagementSave, http, ss);
  }

  override getEditUrlAndMethod(id) {
    const edit = {
      url: environment.apiUrl + API_URL.appManagementGetById,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
    let payload;
    payload = {
      id: data.id,
    };
    return payload;
  }

  createInstance(): AppVersionModel {
    return new AppVersionModel();
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<AppVersionModel> {
    return new Promise<any>((resolve, reject) => {
      // console.log(model, 'model');
      
      resolve(model);
    });
  }

  override getUpdateUrl() {
    return API_URL.appManagementSave;
  }

  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService
        .postData(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

//   override modifyPostModel(formModel: any, dataModel: any) {
//     formModel['creditMasterId'] = dataModel.id;
//     return formModel;
//   }
}
